export const getCurrentRoute = (state) => state.location.type;
export const getRouteArguments = (state) => state.location.payload;
export const getRouteQueryParams = (state) => state.location.query;
